import React from 'react';
import { isMoreLinkEvent } from '../../utils/eventFormatters';
import { getContrastColor, getIconClass } from 'modules/calendarv2/utils/eventColorhelper';
import { adjustColor } from 'utils/colorUtils';

const EventContent = ({ eventInfo, openDayEventsPopup }) => {
  const { event } = eventInfo || {};

  // Handle "more" link
  if (isMoreLinkEvent(event)) {
    const onClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      openDayEventsPopup(event?._def?.extendedProps?.date?.slice(0, 10));
    };
    return (
      <a onClick={onClick} title={event.title} className="fc-daygrid-more-link fc-more-link custom-more-link">
        {event.title}
      </a>
    );
  }

  const { extendedProps, allDay, backgroundColor } = event;
  const bgColor = backgroundColor;
  const textColor = getContrastColor(bgColor);
  const bgColor2 = adjustColor(bgColor, 40);
  const calendarType = extendedProps?.calendar_type || 'event';

  if (extendedProps.calendar_type === 'user') {
    return (
      <div className="minimalist-event-card">
        <div className="event-content-wrapper d-flex align-items-center flex-row gap-2">
          <i
            className={`${getIconClass(calendarType, extendedProps.is_google_event)} event-type-icon`}
            style={{ color: textColor, opacity: 0.9, backgroundColor: bgColor2 }}
            title={calendarType}
          ></i>
          <div className="event-title text-bold" title={extendedProps?.contact_name} style={{ color: textColor }}>
            {extendedProps?.contact_name}
          </div>
        </div>
      </div>
    );
  }
  if (extendedProps.calendar_type === 'case') {
    return (
      <div className="minimalist-event-card">
        <div className="event-content-wrapper d-flex gap-2">
          <div className="d-flex align-items-center flex-row gap-2">
            <i
              className={`${getIconClass(calendarType, extendedProps.is_google_event)} event-type-icon`}
              style={{ color: textColor, opacity: 0.9, backgroundColor: bgColor2 }}
              title={calendarType}
            ></i>
            <span className="text-bold" style={{ color: textColor }}>
              Statute Of Limitations
            </span>
          </div>
          <div className="event-title" title={extendedProps?.case_name} style={{ color: textColor }}>
            {extendedProps?.case_name}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="minimalist-event-card">
      {/* Left accent border */}
      <div className="event-accent" style={{ backgroundColor: textColor, opacity: 0.3 }}></div>

      {/* Event content */}
      <div className="event-content-wrapper">
        {/* Time */}
        {(eventInfo.timeText || allDay) && (
          <div className="event-time" style={{ color: textColor, opacity: 0.9 }}>
            <i
              className={`${getIconClass(calendarType, extendedProps.is_google_event)} event-type-icon`}
              style={{ color: textColor, opacity: 0.9, backgroundColor: bgColor2 }}
              title={calendarType}
            ></i>
            {allDay ? 'All Day' : eventInfo.timeText}
          </div>
        )}

        {/* Title with icon */}
        <div className="event-title-row">
          <div className="event-title" title={event.title} style={{ color: textColor }}>
            {event.title}
          </div>
        </div>

        {/* Subtitle (case name) */}
        {extendedProps?.case_name && (
          <div className="event-subtitle" title={extendedProps.case_name} style={{ color: textColor, opacity: 0.7 }}>
            {extendedProps.case_name}
          </div>
        )}
      </div>
    </div>
  );
};

// Improved memo comparison - checks all relevant properties to prevent unnecessary rerenders
export default React.memo(EventContent, (prevProps, nextProps) => {
  const prevEvent = prevProps.eventInfo.event;
  const nextEvent = nextProps.eventInfo.event;
  const prevExt = prevEvent.extendedProps || {};
  const nextExt = nextEvent.extendedProps || {};

  // Return true if props are equal (skip rerender), false if different (rerender needed)
  return (
    prevEvent.id === nextEvent.id &&
    prevEvent.title === nextEvent.title &&
    prevEvent.backgroundColor === nextEvent.backgroundColor &&
    prevProps.eventInfo.timeText === nextProps.eventInfo.timeText &&
    prevExt.location === nextExt.location &&
    prevExt.isFirmWide === nextExt.isFirmWide &&
    prevExt.isRecurring === nextExt.isRecurring &&
    prevExt.isMoreLink === nextExt.isMoreLink
  );
});
